import React from 'react';
import { Chip } from '@mui/material';
import { STATUS_TONES, StatusTone } from './pvtaStyles';

interface StatusChipProps {
    label: string;
    tone?: StatusTone;
    size?: 'small' | 'medium';
    icon?: React.ReactElement;
    onDelete?: () => void;
}

/**
 * Semantische Status-/Zustands-Pill im PVTA-Stil (success/warning/danger/info/
 * neutral/green/gold). Für dynamisch eingefärbte Fachwerte (Buchungsstatus aus
 * dem Backend, Rollen via GroupChip) bewusst NICHT zuständig.
 */
const StatusChip: React.FC<StatusChipProps> = ({ label, tone = 'neutral', size = 'small', icon, onDelete }) => {
    const t = STATUS_TONES[tone];
    return (
        <Chip
            label={label}
            size={size}
            icon={icon}
            onDelete={onDelete}
            sx={{
                borderRadius: 'var(--pvta-radius-pill)',
                fontWeight: 600,
                backgroundColor: t.bg,
                color: t.color,
                border: '1px solid',
                borderColor: t.border,
                '& .MuiChip-icon': { color: t.color },
                '& .MuiChip-deleteIcon': {
                    color: t.color,
                    opacity: 0.7,
                    '&:hover': { opacity: 1, color: t.color },
                },
            }}
        />
    );
};

export default StatusChip;
